import { hideFromSerialization } from "~/utils";

/**
 * Vue stores internal references on DOM nodes that third-party scripts also
 * touch, using plain assignments that leave them enumerable:
 *
 *   document.body._lpa -> <div id="__nuxt">._vnode -> .component -> .vnode
 *
 * That last hop is circular, so serializing `document.body` throws
 * "Converting circular structure to JSON".
 *
 * WisePops hits this on every popup: its event payload copies `detail.target`
 * (which falls back to `document.body` when no `.wisepops-tab` is mounted) and
 * then `JSON.stringify()`s the result, so the throw surfaces in Sentry as an
 * unhandled TypeError with no frames of ours.
 *
 * Hiding the keys before Vue mounts breaks the reference chain. Vue keeps full
 * read/write access; only enumeration changes, which nothing here relies on.
 */
export default defineNuxtPlugin({
  name: "harden-dom-serialization",
  enforce: "pre",
  setup() {
    const harden = () => {
      hideFromSerialization(document.body, "_lpa");

      const root = document.getElementById("__nuxt");
      hideFromSerialization(root, "_vnode");
      hideFromSerialization(root, "__vue_app__");
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", harden, { once: true });
    } else {
      harden();
    }
  }
});
